export function declination(value, words = []) {
  if (!words.length) return

  let val = Math.abs(value) % 100
  let num = val % 10

  if (val > 10 && val < 20) return words[2]
  if (num > 1 && num < 5) return words[1]
  if (num === 1) return words[0]

  return words[2]
}
